var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 16C14.2085 16 15.9994 14.2091 15.9994 12C15.9994 9.79086 14.2085 8 11.9994 8C9.79026 8 7.9994 9.79086 7.9994 12C7.9994 14.2091 9.79026 16 11.9994 16ZM21.0039 4.00293H3.00391C2.45163 4.00293 2.00391 4.45064 2.00391 5.00293V19.0029C2.00391 19.5552 2.45163 20.0029 3.00391 20.0029H21.0039C21.5562 20.0029 22.0039 19.5552 22.0039 19.0029V5.00293C22.0039 4.45064 21.5562 4.00293 21.0039 4.00293ZM4.00391 15.6463V8.35371C5.12968 8.017 6.01739 7.12892 6.35358 6.00293H17.6452C17.9823 7.13193 18.8738 8.02175 20.0039 8.3564V15.6436C18.8719 15.9788 17.9792 16.8711 17.6434 18.0029H6.35533C6.02047 16.8742 5.13164 15.9836 4.00391 15.6463Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashLine);
export default __webpack_public_path__ + "static/media/cash-line.764e6add1824b5612ae1e47920d23125.svg";
export { ForwardRef as ReactComponent };